import {ReactNode} from 'react';

export function ViewerSlide({children}: {children?: ReactNode}) {
  return (
    <div
      className="flex h-full w-full items-center justify-center"
      style={{
        WebkitBackfaceVisibility: 'hidden',
      }}
    >
      {children}
    </div>
  );
}

export const ViewerSlideType = (<ViewerSlide />).type;
